import {Component} from '@angular/core';
import {showNotification} from "../../events";
import {SfbAssignment, SfbAssignmentGeneric} from "../../model/plot";
import {PlotsService} from "../../services/plots.service";
import {FeatherModule} from "angular-feather";
import {NgxJsonViewerModule} from "ngx-json-viewer";

import {FormsModule} from "@angular/forms";

@Component({
    selector: 'app-sfb-assignment',
    templateUrl: './sfb-assignment.component.html',
    imports: [
    FeatherModule,
    NgxJsonViewerModule,
    FormsModule
],
    styleUrl: './sfb-assignment.component.scss'
})
export class SfbAssignmentComponent {

  assignments: SfbAssignment[] = [];
  unaAssignments: SfbAssignmentGeneric[] = [];
  selectedSfbFiles: File[] = [];
  filtersMinimized = false;
  loading = false;
  readingFile = false;
  sfbAction: 'assign' | 'unassign' | '' = 'assign';
  sfbActionFilters: {label: string, value: 'assign' | 'unassign', columns?: string[]}[] = [
    {label: 'sFB Zuweisung durchführen', value: 'assign', columns: ['map_index', 'operator_id', 'feature_id', 'zone', 'id']},
    {label: 'sFB Zuweisung zurücksetzen', value: 'unassign', columns: ['operator_id', 'feature_id', 'zone', 'id']}
  ]

  constructor(private plotsService: PlotsService) {
  }

  toggleMinimizeFilters() {
    this.filtersMinimized = !this.filtersMinimized;
  }

  onSfbFileSelected(event: any) {
    if (event.target && event.target.files && event.target.files.length >= 1) {
      this.selectedSfbFiles.push(event.target.files[0]);
      this.processSfbFile(event.target.files[0]);
    }
  }

  processSfbFile(file: File) {
    const reader = new FileReader();
    this.readingFile = true;

    reader.onload = (event) => {
      if (event.target && event.target.result) {
        const fileContent = event.target.result;
        const lines = (fileContent as string).split(/\r\n|\n|\r/);

        lines.forEach((line, index) => {
          if (index === 0) {
            const columns = line.split(';');
            const requiredColumns = this.sfbActionFilters.find(filter => filter.value === this.sfbAction)?.columns || [];
            if (requiredColumns.length > 0 && (!requiredColumns.every(column => columns.includes(column))) || columns.length > requiredColumns.length) {
              showNotification.next({
                title: 'Fehler',
                message: `Die sFB-Datei muss (nur) die Spalten ${requiredColumns.join(', ')} enthalten.`,
                class: 'is-danger'
              });
              return;
            }
          }
          if (index >= 1 && line.length > 0) {
            const fields = line.split(';');
            if (this.sfbAction === 'assign') {
              const assignment = {featureId: Number.parseInt(fields[2]), mapIndex: fields[0]};
              let userAssignments = this.assignments.find(assignment => assignment.username === fields[1]);
              if (!userAssignments) {
                userAssignments = {username: fields[1], assignments: []};
                this.assignments.push(userAssignments);
              }
              userAssignments.assignments.push(assignment);
            } else {
              const unAssignment = {featureId: Number.parseInt(fields[1])};
              let userUnassignments = this.unaAssignments.find(assignment => assignment.username === fields[0]);
              if (!userUnassignments) {
                userUnassignments = {username: fields[0], assignments: []};
                this.unaAssignments.push(userUnassignments);
              }
              userUnassignments.assignments.push(unAssignment);
            }
          }
        });
        console.table(this.assignments);
        console.table(this.unaAssignments);
        this.readingFile = false;
      }
    };

    reader.onerror = (event) => {
      console.error("Error occurred while reading the file");
    };

    if (file) {
      reader.readAsText(file);
    }
  }

  async sendSfbChanges() {
    this.loading = true;
    const combinedResponse = this.sfbAction === 'assign' ? await this.plotsService.sendSfbAssignments(this.assignments) : await this.plotsService.removeSfbAssignments(this.unaAssignments);
    this.loading = false;

    let errorMessages = combinedResponse.errors.map((error: any) => error.hasOwnProperty('message') ? error.message : error);
    //TODO collect the successful assignments too and show IDs
    const additionalErrorMessages = combinedResponse.responses
      .map((response: any) => {
        console.log('received combined response in sendSfbChanges', response);
        if (response && response.errors && response.errors.length && response.errors.length >= 1) {
          return response.errors.map((error: any) => error.hasOwnProperty('message') ? error.message : error)
        }
      })
      .flat(1);
    errorMessages = errorMessages
      .concat(additionalErrorMessages)
      .filter(message => !!message);

    if (errorMessages.length > 0) {
      showNotification.next({
        title: 'Fehler',
        message: `Bei der Bearbeitung der Zuweisungen sind Fehler aufgetreten:\n${errorMessages.join('\n')}`,
        class: 'is-danger'
      });
    } else {
      showNotification.next({
        title: 'Zuweisung erfolgreich',
        message: `Die sFB-Zuweisungen wurden erfolgreich in das System übernommen.`,
        class: 'is-success'
      });
    }
  }

  clearData() {
    this.assignments = [];
    this.unaAssignments = [];
    this.selectedSfbFiles = [];
  }

  findRequiredColumns() {
    return this.sfbActionFilters.find(f => f.value === this.sfbAction)?.columns?.join(', ');
  }
  

}
